var map = {
	"./Foto1Info.AVIF": 3711,
	"./Foto2Info.AVIF": 2958,
	"./Foto3Info.AVIF": 6739,
	"./Portada.AVIF": 6046,
	"./layered-waves-black-white 1.AVIF": 7438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7904;